import { useContext, useState } from "react";
import { OnboardingContext } from "../context/OnboardingContext";

export default function OrgDetails() {
  const { sessionId, orgName, adminEmail, setCurrentStep } =
    useContext(OnboardingContext);

  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    org_name: orgName,
    org_type: "",
    admin_first: "",
    admin_last: "",
    address: {
      line1: "",
      city: "",
      state: "",
      country: "",
      zip: ""
    }
  });

  function validate() {
    const e = {};

    if (!form.org_type) e.org_type = "Organization type is required.";
    if (!form.admin_first) e.admin_first = "First name is required.";
    if (!form.admin_last) e.admin_last = "Last name is required.";
    if (!form.address.line1) e.line1 = "Street address is required.";
    if (!form.address.city) e.city = "City is required.";
    if (!form.address.state) e.state = "State is required.";
    if (!form.address.zip) e.zip = "Zip code is required.";
    if (!form.address.country) e.country = "Country is required.";

    setErrors(e);
    return Object.keys(e).length === 0;
  }

  function updateAddress(field, value) {
    setForm({
      ...form,
      address: { ...form.address, [field]: value }
    });
  }

  async function submit() {
    if (!validate()) return;

    const res = await fetch("/api/admin-onboarding/organization-details", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        session_id: sessionId,
        ...form
      })
    });

    const data = await res.json();
    if (data.next_step === "billing") {
      setCurrentStep("billing");
    }
  }

  return (
    <div>
      <h2>Organization Details</h2>
      <p>Please provide the required information to set up your organization.</p>

      <label>Organization Name</label>
      <input value={form.org_name} readOnly />

      <label>Organization Type</label>
      <select
        value={form.org_type}
        onChange={(e) =>
          setForm({ ...form, org_type: e.target.value })
        }
      >
        <option value="">Select Organization Type</option>
        <option value="Biotech">Biotech</option>
        <option value="Biopharma">Biopharma</option>
        <option value="Academic Lab">Academic Lab</option>
        <option value="Hospital">Hospital</option>
        <option value="Nonprofit">Nonprofit</option>
        <option value="Other">Other</option>
      </select>
      {errors.org_type && <div className="error">{errors.org_type}</div>}

      <label>Admin First Name</label>
      <input
        value={form.admin_first}
        onChange={(e) =>
          setForm({ ...form, admin_first: e.target.value })
        }
      />
      {errors.admin_first && <div className="error">{errors.admin_first}</div>}

      <label>Admin Last Name</label>
      <input
        value={form.admin_last}
        onChange={(e) =>
          setForm({ ...form, admin_last: e.target.value })
        }
      />
      {errors.admin_last && <div className="error">{errors.admin_last}</div>}

      <label>Admin Email</label>
      <input value={adminEmail} readOnly />

      <label>Street Address</label>
      <input
        value={form.address.line1}
        onChange={(e) => updateAddress("line1", e.target.value)}
      />
      {errors.line1 && <div className="error">{errors.line1}</div>}

      <label>City</label>
      <input
        value={form.address.city}
        onChange={(e) => updateAddress("city", e.target.value)}
      />
      {errors.city && <div className="error">{errors.city}</div>}

      <label>State</label>
      <input
        value={form.address.state}
        onChange={(e) => updateAddress("state", e.target.value)}
      />
      {errors.state && <div className="error">{errors.state}</div>}

      <label>Zip Code</label>
      <input
        value={form.address.zip}
        onChange={(e) => updateAddress("zip", e.target.value)}
      />
      {errors.zip && <div className="error">{errors.zip}</div>}

      <label>Country</label>
      <input
        value={form.address.country}
        onChange={(e) => updateAddress("country", e.target.value)}
      />
      {errors.country && <div className="error">{errors.country}</div>}

      <button onClick={submit}>Continue</button>
    </div>
  );
}